/**
 * Слой достоверности цифры в Context Audit.
 *
 * MEASURED — прямой счёт из подключённого источника, каждая цифра раскрывается
 * в список конкретных объектов (drill-down).
 * ESTIMATE — инференс, прокси или деньги: показывается диапазоном с видимыми
 * допущениями и никогда не втекает в нижнюю границу заголовочной полосы.
 */
export var ContextAuditMetricLayer;
(function (ContextAuditMetricLayer) {
    ContextAuditMetricLayer["MEASURED"] = "measured";
    ContextAuditMetricLayer["ESTIMATE"] = "estimate";
})(ContextAuditMetricLayer || (ContextAuditMetricLayer = {}));
//# sourceMappingURL=context-audit-metric-layer.enum.js.map